var version = "9.14.5";

export { version as v };
//# sourceMappingURL=package-55452086.js.map
